
import modal from '~/mixins/modal'

export default {
  mixins: [modal],
  data () {
    return {
      id: crypto.randomUUID(),
      loading: false,
      message: '',
    }
  },
  computed: {
    supportEmail () {
      return this.$store.getters['auth/supportEmail']
    }
  },
  methods: {
    resetAndFocusMessage () {
      this.message = ''
      this.$nextTick(() => this.$refs.message.focus())
    },
    async submit () {
      try {
        this.loading = true
        await this.$axios.post('/v2/hubspot/contact-request', {
          message: this.message,
        })
        this.$tracker.submitContactForm()
        this.showSuccess(this.$t('c.common.sales-form-modal.sent-text'), this.$t('c.common.sales-form-modal.sent-title'))
        this.isModalOpen = false
      } catch (e) {
        this.$log.error(e)
        this.showError(this.$t('c.common.sales-form-modal.error'))
      } finally {
        this.loading = false
      }
    }
  }
}
